// extracted by css-extract-rspack-plugin
export default {"link":"_ayyt","card":"eFUb9","skeletonCard":"UzR0X","body":"EsGSe","icon":"zHnMp","content":"Myk1X","titleRow":"XJnbK","description":"E4mbc","actions":"IwOng"};